export default {
  ...window.env,
  init: async () => {},
};
